import { render, staticRenderFns } from "./QuoteModifications.vue?vue&type=template&id=e6a1b010&"
import script from "./QuoteModifications.vue?vue&type=script&lang=js&"
export * from "./QuoteModifications.vue?vue&type=script&lang=js&"
import style0 from "./QuoteModifications.vue?vue&type=style&index=0&id=e6a1b010&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports